import * as React from "react";

import {
    Bar,
    Breakpoint,
    DiversitySectionContainer,
    DiversitySectionMobileContainer,
    MarketResearchDiversityMetricData,
    percentCompactFormatter,
    Text,
    useDeviceSize,
} from "../../..";
import { DiversityMobileSection } from "./diversityMobileSection";
import { DiversityDesktopSection } from "./diversityDesktopSection";

type DiversitySectionProps = {
    title: string;
    graphTitle: string;
    name: string;
    statePercent: number;
    regionalPercent: number;
    metrics: MarketResearchDiversityMetricData[];
    metricName: string;
    gauge: React.ReactNode;
    isLocationRemote?: boolean;
    normalizedLocationName: string;
    stateName: string;
};
export const DiversitySection = (props: DiversitySectionProps) => {
    const {
        title,
        name,
        statePercent,
        regionalPercent,
        metrics,
        metricName,
        graphTitle,
        gauge,
        isLocationRemote,
        normalizedLocationName,
        stateName,
    } = props;
    const device = useDeviceSize();

    const bars = (metric: MarketResearchDiversityMetricData) => {
        if (isLocationRemote) {
            return null;
        }

        return (
            <>
                <Bar
                    percent={metric.regionalPercent}
                    color="#7E66D8"
                    showPercent
                    key="regionalBar"
                />
                <Bar
                    percent={metric.statePercent}
                    color="#E35AFC"
                    showPercent
                    key="stateBar"
                />
            </>
        );
    };

    const comparisonText = (regional: number, comp: number) => {
        const highComp = comp * 1.2;
        const lowComp = comp * 0.8;
        if (regional >= lowComp && regional <= highComp)
            return "consistent with";
        if (regional > highComp) return "greater than";
        return "lower than";
    };

    const summaryText = () => (
        <>
            <Text variant="body1">
                {`${name} in ${normalizedLocationName} is ${comparisonText(
                    regionalPercent,
                    statePercent
                )} the statewide average. `}
                <Breakpoint desktop>
                    <br />
                </Breakpoint>
                {`Specifically, ${percentCompactFormatter.format(
                    regionalPercent / 100
                )}
                                of the workforce is ${metricName} while the
                                ${stateName} average is
                                ${percentCompactFormatter.format(
                                    statePercent / 100
                                )}.`}
            </Text>
        </>
    );

    return (
        <>
            {device === "mobile" ? (
                <DiversitySectionMobileContainer>
                    <DiversityMobileSection
                        summaryText={summaryText}
                        title={title}
                        graphTitle={graphTitle}
                        bars={bars}
                        gauge={gauge}
                        isLocationRemote={isLocationRemote}
                        metrics={metrics}
                    />
                </DiversitySectionMobileContainer>
            ) : (
                <DiversitySectionContainer>
                    <DiversityDesktopSection
                        summaryText={summaryText}
                        title={title}
                        graphTitle={graphTitle}
                        bars={bars}
                        gauge={gauge}
                        metrics={metrics}
                        isLocationRemote={isLocationRemote}
                    />
                </DiversitySectionContainer>
            )}
        </>
    );
};
